import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "facebook",
  "use": "facebook-usage",
  "viewBox": "0 0 29 28.82",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 29 28.82\" id=\"facebook\">\r\n  <path d=\"M29,14.5A14.5,14.5,0,1,0,12.23,28.82V18.69H8.55V14.5h3.68V11.31c0-3.64,2.17-5.65,5.48-5.65A21.47,21.47,0,0,1,21,6V9.52H19.13a2.09,2.09,0,0,0-2.35,1.79,2.48,2.48,0,0,0,0,.47V14.5h4l-.65,4.19H16.77V28.82A14.49,14.49,0,0,0,29,14.5\" fill-rule=\"evenodd\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol